module.exports = {
    "source_code": "HLXEMS",
    "site_id": "dnpinfo.saintmarys.edu",
    "title": "Saint Mary's College",
    "tfn": "",
    "url": "https://dnpinfo.saintmarys.edu",
    "gtm_code": "GTM-NQS2WN3",
}